module.exports = __webpack_public_path__ + "img/4d5e12c.png";